export const SourceSystems = {
  MKG: 'MKG',
  Bemet: 'Bemet',
  proMExS: 'proMExS',
  SAP: 'SAP',
  Imnoo: 'Imnoo',
} as const;

export const ERP_SYSTEM_CONNECTION_TYPE = {
  MKG_API: 'MkgApi',
  MKG_ODBC: 'Odbc',
  Bemet: 'Npgsql',
  proMExS: 'SqlClient',
};

export const erpIgnoreFields = [
  'PartitionKey',
  'RowKey',
  'Timestamp',
  'Timestamp@odata.type',
  'odata.metadata',
  'odata.type',
  'odata.id',
  'odata.etag',
  'odata.editLink',
];

export const withERP = (isWithERP: unknown) => typeof isWithERP === 'boolean' && !!isWithERP;
